import React from "react";
import { Link, useLocation } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const CategoryHeader = ({ reloadLabelList, changeStatusHandler }) => {
  const location = useLocation();
  const moduleName = location.pathname;
  const currentModule = moduleName.split("/").pop(); // Split by '/' and get the last element

  const { t } = useTranslation(); //for translation
  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("Administration"), link: "/admin/administration" },
    { title: t(`Category / ${currentModule}`) },
  ];

  return (
    <div className="bg-white pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadLabelList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
            style={{ minWidth: 110 }}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          <div className="dropdown">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  onClick={changeStatusHandler}
                >
                  <span className="material-symbols-outlined icon-sm text-danger">
                    delete
                  </span>
                  <span>{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>
          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#categoryFilter"
            aria-controls="categoryFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
          <Link
            to="/admin/administration/categories/save"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CategoryHeader;
